// extracted by mini-css-extract-plugin
export default {"item":"Skeleton__item--lc-r54rJ"};